import TokenSetup from "./TokenSetup";

export default TokenSetup;
